import React, { useEffect, useRef, useState } from "react"

// icons
import { CgArrowLongDown } from "react-icons/cg";
import { TfiWrite } from "react-icons/tfi";


const auditScoreHeight = {
    M: {
        정상: 9,
        위험: 19,
        장애: 40
    },
    F: {
        정상: 5,
        위험: 9,
        장애: 40
    }
}

export function Module1BoxItem({patientSex, auditScore}) {

    return (
        <div className="module_graph_box_item">
            <div className="box_header">
                <div className="title">알코올 사용장애 선별검사(AUDIT-K) 점수</div>
                <div className="legend_wrapper">
                    <div className="legend_item">
                        <div className="legend_item_icon red" />
                        <p>알코올사용장애</p>
                    </div>
                    <div className="legend_item">
                        <div className="legend_item_icon yellow" />
                        <p>위험 음주군</p>
                    </div>
                    <div className="legend_item">
                        <div className="legend_item_icon green" />
                        <p>정상 음주군</p>
                    </div>
                </div>
            </div>
            <div className="box_body">
                <div className="audit_graph">
                    <div className="graph_y_axis">
                        {new Array(8).fill(0).map((_, idx)=>(
                            <div key={idx} className="graph_y_axis_item" style={{ bottom: `${(idx + 1) * 12.5}%`}}>{(idx + 1) * 5}</div>
                        ))}
                        {auditScore!==0 && <div className="user_y_axis_marker" style={{ bottom: `${auditScore*2.5}%` }}>{auditScore}</div>}
                    </div>
                    <div className="graph_content">
                        {new Array(8).fill(0).map((_, idx)=>(
                            <div key={idx} className="graph_content_item" />
                        ))}
                        {auditScore!==0 && <div className="user_audit_score" style={{ height: `${auditScore*2.5}%`}} />}
                        {auditScore!==0 && <div className="user_audit_score_line" style={{ height: `${auditScore*2.5}%`}} />}
                        {patientSex && (
                            <div className="audit_score_wrapper">
                                <div className="normal_audit_score" style={{ height: `${auditScoreHeight[patientSex].정상 * 2.5}%` }} />
                                <div className="danger_audit_score" style={{ height: `${auditScoreHeight[patientSex].위험 * 2.5}%` }} />
                                <div className="disorder_audit_score" style={{ height: `${auditScoreHeight[patientSex].장애 * 2.5}%` }} />
                            </div>
                        )}                                    
                    </div>
                </div>
            </div>
        </div>
    )
}

const rtcqStageColor = {
    전숙고단계 : 'black',
    숙고단계 : 'purple',
    준비단계 : 'yellow',
    실행단계 : 'blue',
    유지단계 : 'green'
}

export function Module2BoxItem({rtcqStage}) {

    return (
        <div className="module_graph_box_item">
            <div className="box_header">
                <div className="title">치료용 변화준비척도(RTCQ) 단계</div>
            </div>
            <div className="box_body">
                {rtcqStage && <div className={`body_rtcq_stage ${rtcqStage ? rtcqStageColor[rtcqStage] : ""}`}>
                    {rtcqStage}
                </div>}
            </div>
        </div>
    )
}

export function Module3Box23Item({answerList}) {

    return (
        <div className="module_graph_box_item">
            <div className="box_header">
                <div className="title">음주습관</div>
            </div>
            <div className="box_body">
                <div className="box_text_wrapper">
                    <div className="box_text_content">
                        {answerList[0].answer.map((e, idx)=>(
                            <div key={idx} className="box_text_item">
                                {e}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export function Module3Box34Item({answerList}) {

    return (
        <div className="module_graph_box_item">
            <div className="box_header">
                <div className="title">음주갈망 조절</div>
            </div>
            <div className="box_body">
                <div className="box_text_wrapper">
                    <div className="box_text_wrapper_item">
                        <div className="box_text_title">명상 전</div>
                        <div className="box_text_content">
                            {answerList[0] && answerList[0].answer.map((e, idx)=>(
                                <div key={idx} className="box_text_item">
                                    {e}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="box_text_wrapper_item">
                        <div className="box_text_title">명상 후</div>
                        <div className="box_text_content">
                            {answerList[1] && answerList[1].answer.map((e, idx)=>(
                                <div key={idx} className="box_text_item">
                                    {e}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export function Module4Box40Item({answerList}) {

    return (
        <div className="module_graph_box_item">
            <div className="box_header">
                <div className="title" style={{ textAlign: 'center' }}>급성 알코올 중독 증상</div>
            </div>
            <div className="box_body" style={{ gap: '0.3125rem' }}>
                <div className="box_text_wrapper" style={{width: 'calc(50% - 0.3125rem)'}}>
                    <div className="box_text_title">알코올 증상 경험</div>
                    <div className="box_text_content">
                        {answerList[0] && answerList[0].answer.map((e, idx)=>(
                            <div key={idx} className="box_text_item">
                                {e}
                            </div>
                        ))}
                    </div>
                </div>
                <div style={{ width: 0, height: 'calc(100% - 1.25rem)', border: '1px solid #707070', margin: '0.625rem 0', opacity: '0.7' }} />
                <div className="box_text_wrapper" style={{width: 'calc(50% - 0.3125rem)'}}>
                    <div className="box_text_title">알코올 후유증 경험</div>
                    <div className="box_text_content">
                        {answerList[1] && answerList[1].answer.map((e, idx)=>(
                            <div key={idx} className="box_text_item">
                                {e}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export function Module4Box43Item({answerList}) {
    const [isClicked, setIsClicked] = useState(false);

    return (
        <div className="module_graph_box_item">
            <div className="box_header">
                <div className="title">신체적 의존 현상</div>
            </div>
            <div className="box_body">
                <div className="box_text_wrapper" style={{ gap: 0 }}>
                    <div className="arrow_wrapper">
                        <span>클릭 화살표</span>
                        <div className="outer_arrow" />
                        <div className="inner_arrow" />
                    </div>
                    <div className="box_text_content">
                        {answerList[0] && answerList[0].answer.map((e, idx)=>(
                            <button
                                key={idx}
                                className="box_text_item"
                                style={{ width: '9.375rem' }}
                                onClick={()=>setIsClicked(!isClicked)}
                            >
                                {e}
                            </button>
                        ))}
                    </div>
                    {isClicked && answerList[1] && <div style={{ width: '100%', textAlign: 'center', margin: '0.625rem 0'}}>
                        <CgArrowLongDown style={{ fontSize: '2rem', color: '#707070'}} />
                    </div>}
                    {isClicked && answerList[1] && <div className="box_text_content">
                        {answerList[1] && answerList[1].answer.map((e, idx)=>(
                            <div key={idx} className="box_text_item">
                                {e}
                            </div>
                        ))}
                    </div>}
                </div>               
            </div>
        </div>
    )
}

export function Module5BoxItem({answerList}) {

    return (
        <div className="module_graph_box_item">
            <div className="box_header">
                <div className="title">서포터</div>
            </div>
            <div className="box_body">
                <div className="supporter_viewer">
                    <div className="supporter_list_wrapper">
                        {answerList.map((answerItem, answerIdx) => (
                            <div key={answerIdx} className="supporter_item">
                                <div className="content">{answerItem.name}</div>
                                <div className="footer">{answerItem.relationName}</div>
                            </div>
                        ))}
                    </div>
                </div>                
            </div>
        </div>
    )
}

export function Module5Box51Item({answerList}) {

    return (
        <div className="module_graph_box_item">
            <div className="box_header">
                <div className="title">방해요소 정리</div>
            </div>
            <div className="box_body">
                <div className="box_list_wrapper">
                    <div className="border_box_with_header">
                        <div className="item_wrapper">
                            <div className="header">누구와 함께 정리할 계획?</div>
                            <div className="text_viewer">
                                <div className="text_content">
                                    {answerList[0] && answerList[0].answer.map((e, idx)=>(
                                        <div key={idx} className="text_item">
                                            {e}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="item_wrapper">
                            <div className="header">금주 방해 요소</div>
                            <div className="text_viewer">
                                <div className="text_content">
                                    {answerList[1] && answerList[1].answer.map((e, idx)=>(
                                        <div key={idx} className="text_item">
                                            {e}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="border_box_with_header">
                        <div className="header">언제 정리할 계획?</div>
                        <div className="text_viewer">
                            <div className="text_content">
                                {answerList[2] && answerList[2].answer.map((e, idx)=>(
                                    <div key={idx} className="text_item">
                                        {e}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export function Module5Box127Item({answerList}) {

    return (
        <div className="module_graph_box_item">
            <div className="box_header" style={{ border: 'none' }}>
                <div className="title">금주환경 조성</div>
            </div>
            <div className="box_body">
                <div className="box_text_wrapper" style={{ padding: 0, overflow: 'hidden', gap: 0 }}>
                    <div className="box_text_header" style={{ padding: '0.3125rem 0' }}>음주 대체 여가활동</div>
                    <div className="box_text_viewer">
                        <div className="box_text_content" style={{ padding: '1.25rem 0.625rem' }}>
                            {answerList[0].answer.map((e, idx)=>(
                                <div key={idx} className="box_text_item">
                                    {e}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export function Module7BoxItem({answerList}) {
    const [selectedScore, setSelectedScore] = useState(-1);
    const [selectedItem, setSelectedItem] = useState('none');

    const lineWidth = ['3.75rem', '1.25rem', '-1.25rem'];
    
    return (
        <div className="module_graph_box_item">
            <div className="box_header" style={{ border: 'none' }}>
                <div className="title" style={{ textAlign: 'center' }}>음주 거절 효능감 그래프</div>
            </div>
            <div className="box_body" style={{ flexDirection: 'column' }}>
                <div className="audit_graph" style={{ height: 'calc(100% - 3.125rem)', paddingBottom: 0 }}>
                    <div className="graph_y_axis">
                        {/* 음주 거절 효능감 그래프의 최대 점수는 114점 -> 20단위로 axis 표시 (0 ~ 120) */}
                        {new Array(7).fill(0).map((_, idx)=>(
                            <div key={idx} className="graph_y_axis_item" style={{ bottom: `${(idx) * 16.67}%`}}>{(idx) * 20}</div>
                        ))}
                        {selectedScore>=0 && <div className="user_y_axis_marker" style={{ bottom: `${selectedScore/120*100}%`, color: '#FF0000' }}>{selectedScore}</div>}
                    </div>
                    <div className="graph_content">
                        {new Array(6).fill(0).map((_, idx)=>(
                            <div key={idx} className="graph_content_item" style={{ height: '16.67%' }} />
                        ))}
                        {answerList[0] && <div className="graph_item_list_wrapper">
                            {Boolean(answerList[0].scoreEmotion) && (
                                <div
                                    className={`item_bar ${selectedItem===0 ? "selected" : ""}`}
                                    style={{ height: `${answerList[0].scoreEmotion/120*100}%`}}
                                    onMouseEnter={()=>{
                                        setSelectedScore(answerList[0].scoreEmotion);
                                        setSelectedItem(0);
                                    }}
                                    onMouseLeave={() => {
                                        setSelectedScore(-1);
                                        setSelectedItem('none');
                                    }}
                                    title={answerList[0].scoreEmotion}
                                />
                            )}
                            {Boolean(answerList[0].scorePressure) && (
                                <div
                                    className={`item_bar ${selectedItem===1 ? "selected" : ""}`}
                                    style={{ height: `${answerList[0].scorePressure/120*100}%`, backgroundColor: '#174A84'}}
                                    onMouseEnter={()=>{
                                        setSelectedScore(answerList[0].scorePressure);
                                        setSelectedItem(1);
                                    }}
                                    onMouseLeave={() => {
                                        setSelectedScore(-1);
                                        setSelectedItem('none');
                                    }}
                                    title={answerList[0].scorePressure}
                                />
                            )}
                            {Boolean(answerList[0].scoreOpportunity) && (
                                <div
                                    className={`item_bar ${selectedItem===2 ? "selected" : ""}`}
                                    style={{ height: `${answerList[0].scoreOpportunity/120*100}%`, backgroundColor: '#FF0000'}}
                                    onMouseEnter={()=>{
                                        setSelectedScore(answerList[0].scoreOpportunity);
                                        setSelectedItem(2);
                                    }}
                                    onMouseLeave={() => {
                                        setSelectedScore(-1);
                                        setSelectedItem('none');
                                    }}
                                    title={answerList[0].scoreOpportunity}
                                />
                            )}
                        </div>}
                        {selectedScore>=0 && (
                            <div
                                className="user_audit_score_line"
                                style={{
                                    width: `calc(50% - ${lineWidth[selectedItem]})`,
                                    bottom: `${selectedScore/120*100}%`,
                                    borderColor: '#FF0000',
                                    height: 0, transform: 'translate(0, 1px)'
                                }}
                            />
                        )}                        
                    </div>
                </div>
                <div className="rejection_graph_info">
                    <div className="graph_title">음주 거절 효능감</div>
                    <div className="graph_legend">
                        <div className="legend_item">
                            <div className="legend_icon" style={{ backgroundColor: '#eec245'}} />
                            <span>정서적해소유형</span>
                        </div>
                        <div className="legend_item">
                            <div className="legend_icon" style={{ backgroundColor: '#174A84'}} />
                            <span>사회적압박유형</span>
                        </div>
                        <div className="legend_item">
                            <div className="legend_icon" style={{ backgroundColor: '#FF0000'}} />
                            <span>음주기회유형</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export function Module7Box61Item({answerList}) {

    return (
        <div className="module_graph_box_item">
            <div className="box_header">
                <div className="title">행동대처 전략</div>
            </div>
            <div className="box_body">
                <div className="box_text_wrapper">
                    <div className="box_text_content">
                        {answerList[0].answer.map((e, idx)=>(
                            <div key={idx} className="box_text_item">
                                {e}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export function Module8Box66Item({answerList}) {

    return (
        <div className="module_graph_box_item">
            <div className="box_header">
                <div className="title">과음에서 벗어나기 위한 행동</div>
            </div>
            <div className="box_body">
                <div className="box_text_wrapper">
                    <div className="box_text_wrapper_item">
                        <div className="box_text_title">행동</div>
                        <div className="box_text_content">
                            {answerList[0] && answerList[0].answer.map((e, idx)=>(
                                <div key={idx} className="box_text_item">
                                    {e}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export function Module8Box67Item({answerList}) {

    return (
        <div className="module_graph_box_item">
            <div className="box_header">
                <div className="title">과음에서 벗어나기 위한 한계</div>
            </div>
            <div className="box_body">
                <div className="box_text_wrapper">
                    <div className="box_text_wrapper_item">
                        <div className="box_text_title">한계</div>
                        <div className="box_text_content">
                            {answerList[0] && answerList[0].answer.map((e, idx)=>(
                                <div key={idx} className="box_text_item">
                                    {e}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export function Module9Box72Item({answerList}) {

    return (
        <div className="module_graph_box_item">
            <div className="box_header">
                <div className="title">경고신호사고</div>
            </div>
            <div className="box_body">
                <div className="box_text_wrapper">
                    <div className="box_text_content">
                        {answerList[0].answer.map((e, idx)=>(
                            <div key={idx} className="box_text_item">
                                {e}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

function DescriptionItem({answerList, idx, title}) {
    const textRef = useRef(null);
    const [needOpenBtn, setNeedOpenBtn] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(()=>{
        if(textRef.current){
            if(textRef.current.offsetHeight < textRef.current.scrollHeight) {
                setNeedOpenBtn(true);
            }
        }
    },[textRef.current])

    return (
        <div className="description_item">
            <div className="description_title">{title}</div>
            <div className='description_content'>
                <TfiWrite />
                <p ref={textRef} className={`${isOpen ? "open" : ""}`}>{answerList[idx] ? answerList[idx].answer.join(', ') : ""}</p>
                {needOpenBtn && <button
                    onClick={()=>setIsOpen(!isOpen)}
                >{isOpen ? '접기' : '더보기'}</button>}
            </div>
        </div>
    )
}

export function Module11Box144Item({answerList}) {
    const titleList = ['부정적 감정 생기는 상황', '구체적 기분', '그때 느껴지는 신체 감각', '그때 드는 생각', '표현 방식'];
    
    return (
        <div className="module_graph_box_item">
            <div className="box_header">
                <div className="title">부정적감정 알아차리기</div>
            </div>
            <div className="box_body">
                <div className="box_text_wrapper">
                    {titleList.map((e, idx) => (
                        <DescriptionItem
                            key={idx}
                            answerList={answerList}
                            idx={idx}
                            title={e}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

export function Module11Box149Item({answerList}) {
    const titleList = ['이완하기', '즐거운 활동하기', '적극적 표현하기', '사회적 지지 관련'];
    
    return (
        <div className="module_graph_box_item">
            <div className="box_header">
                <div className="title">부정적감정 대처 전략</div>
            </div>
            <div className="box_body">
                <div className="box_text_wrapper">
                    {titleList.map((e, idx) => (
                        <DescriptionItem
                            key={idx}
                            answerList={answerList}
                            idx={idx}
                            title={e}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

export function Module12Box92Item({answerList}) {
    return (
        <div className="module_graph_box_item">
            <div className="box_header">
                <div className="title">재발 위험 신호</div>
            </div>
            <div className="box_body">
                <div className="box_text_wrapper">
                    <div className="box_text_content">
                        {answerList[0].answer.map((e, idx)=>(
                            <div key={idx} className="box_text_item">
                                {e}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export function Module12Box102Item({answerList}) {

    return (
        <div className="module_graph_box_item">
            <div className="box_header">
                <div className="title">삶의 균형감 회복 도구</div>
            </div>
            <div className="box_body" style={{ padding: '1.25rem 0.625rem'}}>
                <div className="description_box">
                    <div className="icon"><TfiWrite /></div>
                    <div className="header">
                        <p>감사하게 느끼는 것</p>
                    </div>
                    <div className="content_wrapper">
                        <div className="content_list">
                            {answerList[0] && answerList[0].answer.map((e, idx)=>(
                                <div key={idx} className="content_item">
                                    <strong>{idx+1}. </strong>{e}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export function Module12Box103Item({answerList}) {

    return (
        <div className="module_graph_box_item">
            <div className="box_header">
                <div className="title">삶의 균형감 회복 도구</div>
            </div>
            <div className="box_body" style={{ padding: '1.25rem 0.625rem', flexDirection: 'column', gap: '0.625rem'}}>
                <div className="description_box" style={{ height: '6.25rem', minHeight: '6.25rem' }}>
                    <div className="icon"><TfiWrite /></div>
                    <div className="header">
                        <p>봉사</p>
                    </div>
                    <div className="content_wrapper">
                        <div className="content_list" style={{ gap: '0.5rem'}}>
                            {answerList[0] && answerList[0].answer.map((e, idx)=>(
                                <div key={idx} className="content_item">
                                    <strong>{idx+1}. </strong>{e}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="description_box" style={{ height: 'calc(100% - 6.25rem', overflow: 'auto', border: 'none'}}>
                    <div className="header" style={{ transform: 'none', position: 'relative', marginBottom: '0.625rem' }}>
                        <p>긴장상태</p>
                    </div>
                    <div className="box_text_content" style={{ gap: '0.3125rem'}}>
                        {answerList[1] && answerList[1].answer.map((e, idx)=> (
                            <div key={idx} className="box_text_item" style={{ fontSize: '0.625rem', lineHeight: '100%', padding: '0.1875rem 1rem'}}>{e}</div>
                        ))}
                        {answerList[2] && answerList[2].answer.map((e, idx)=> (
                            <div key={idx} className="box_text_item" style={{ fontSize: '0.625rem', lineHeight: '100%', padding: '0.1875rem 1rem'}}>{e}</div>
                        ))}
                    </div>                    
                </div>
            </div>
        </div>
    )
}